import useInfinitiveScrollableWire from '../../shared/infinitive-scrollable-wires-hook';
import wireName from './utils';

const useScrollableWires = props => useInfinitiveScrollableWire({ ...props, wireName, entityName: 'wires' });
export default useScrollableWires;
